/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConfidenceReference = {
    Scale0To1: 'Scale0To1',
    Scale0To100: 'Scale0To100',
    Scale0To255: 'Scale0To255'
} as const;
export type ConfidenceReference = typeof ConfidenceReference[keyof typeof ConfidenceReference];

